import { render, staticRenderFns } from "./sp-organisation-details.vue?vue&type=template&id=2fc9136b&"
import script from "./sp-organisation-details.vue?vue&type=script&lang=js&"
export * from "./sp-organisation-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports